export default "__VITE_ASSET__67bceaf7__"